@use '@helsenorge/designsystem-react/scss/screen-reader' as *;

.language-picker {
  &__message {
    @include sr-only;
  }
}
